(() => {
  const moneyFallback = (cents, currency='MYR') => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  const formatShopMoney = (cents) => {
    const format = window.PNE_MONEY_FORMAT || 'RM {{amount}}';
    const value = (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/{{\s*amount(?:_with_comma_separator|_no_decimals|_no_decimals_with_comma_separator)?\s*}}/, value);
  };

  const bucksReconvert = () => { try { ((window || {}).bucksCC || {}).reConvert && window.bucksCC.reConvert(); } catch(e) {} };

  const q = (s, c=document) => c.querySelector(s);
  const qa = (s, c=document) => [...c.querySelectorAll(s)];

  // Mobile nav
  qa('[data-menu-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    const open = nav.hasAttribute('hidden');
    nav.toggleAttribute('hidden', !open);
    btn.setAttribute('aria-expanded', String(open));
  }));

  // Cart drawer
  const drawer = q('#PneCartDrawer');
  let cartCurrency = 'MYR';
  const formatCartMoney = (cents) => { try { return moneyFallback(cents, cartCurrency); } catch(e) { return formatShopMoney(cents); } };
  async function refreshCart(open=true) {
    if (!drawer) return;
    try {
      const cart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
      cartCurrency = cart.currency || cartCurrency;
      qa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      const body=q('[data-cart-items]',drawer), subtotal=q('[data-cart-subtotal]',drawer);
      if (subtotal) { subtotal.innerHTML=formatShopMoney(cart.total_price); }
      if (body) {
        body.innerHTML = cart.items.length ? cart.items.map((item,index)=>`
          <div class="pne-drawer-line">
            ${item.image ? `<img src="${item.image}" alt="">` : ''}
            <div><a href="${item.url}">${item.product_title}</a><small>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</small>${formatShopMoney(item.final_line_price)}</div>
            <div class="pne-drawer-qty"><button type="button" data-cart-change="${index+1}" data-qty="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index+1}" data-qty="${item.quantity+1}">+</button></div>
          </div>`).join('') : '<p class="pne-muted">Your collector bag is empty.</p>';
      }
      bucksReconvert();
      if (open) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('pne-no-scroll'); }
    } catch(e) { console.warn('PNE cart refresh failed', e); }
  }
  qa('[data-cart-open]').forEach(btn=>btn.addEventListener('click',()=>refreshCart(true)));
  qa('[data-cart-close]').forEach(btn=>btn.addEventListener('click',()=>{ if(!drawer)return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('pne-no-scroll'); }));
  drawer?.addEventListener('click', async e => {
    const btn=e.target.closest('[data-cart-change]'); if(!btn)return;
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(btn.dataset.cartChange),quantity:Number(btn.dataset.qty)})});
    refreshCart(true);
  });

  // Home vault hero
  qa('[data-vault-hero]').forEach(root => {
    const stage=q('[data-vault-stage]',root), gallery=q('[data-vault-gallery]',root), images=qa('[data-vault-image]',root);
    const cta=q('[data-vault-cta]',root), price=q('[data-vault-price]',root), title=q('[data-vault-title]',root), code=q('[data-vault-code]',root), route=q('[data-vault-route]',root);
    let selectedUrl = cta?.getAttribute('href') || '#';
    qa('[data-vault-edition]',root).forEach(btn => btn.addEventListener('click',()=>{
      qa('[data-vault-edition]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      images.forEach(img=>img.classList.toggle('is-active',img.dataset.vaultImage===btn.dataset.vaultEdition));
      root.classList.toggle('pne-accent-blue',btn.dataset.accent==='blue');
      if (title) title.textContent=btn.dataset.title;
      if (code) code.textContent=btn.dataset.code;
      if (price) { price.innerHTML=formatShopMoney(Number(btn.dataset.priceCents || 0)); price.classList.remove('pne-price-in'); void price.offsetWidth; price.classList.add('pne-price-in'); }
      selectedUrl=btn.dataset.url; bucksReconvert();
      if (cta && !cta.dataset.quoteMode) cta.href=selectedUrl;
    }));
    qa('[data-vault-region]',root).forEach(btn=>btn.addEventListener('click',()=>{
      qa('[data-vault-region]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      const quote=btn.dataset.vaultRegion==='quote';
      if(route) route.textContent=quote?'Europe / Other · Quote required':`${btn.textContent.trim().startsWith('U.S.')?'U.S.':'Asia'} · Direct checkout`;
      if(cta){
        if(quote){cta.dataset.quoteMode='1';cta.textContent=document.documentElement.dataset.quoteLabel || 'Request Shipping Quote';cta.classList.add('pne-btn--outline');cta.classList.remove('pne-btn--gold');cta.href=window.PNE_QUOTE_URL || '#';}
        else{delete cta.dataset.quoteMode;cta.textContent='View Selected Edition';cta.classList.add('pne-btn--gold');cta.classList.remove('pne-btn--outline');cta.href=selectedUrl;}
      }
    }));
    qa('[data-vault-view]',root).forEach((btn,i)=>btn.addEventListener('click',()=>{
      qa('[data-vault-view]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      const img=q('.pne-stage__image.is-active',root); if(!img)return;
      img.style.transform=`scale(${1+i*.014}) translateX(${i===1?-1.1:i===2?1.1:0}%)`; setTimeout(()=>img.style.transform='',430);
    }));
    if(stage && gallery && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      stage.addEventListener('mousemove',e=>{const r=stage.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;gallery.style.transform=`rotateX(${(y-.5)*-2.4}deg) rotateY(${(x-.5)*3.5}deg) scale(1.005)`;stage.style.setProperty('--mx',`${x*100}%`);stage.style.setProperty('--my',`${y*100}%`)});
      stage.addEventListener('mouseleave',()=>gallery.style.transform='');
    }
  });

  // Product page
  const initProductSection = (root) => {
    if (!root || root.dataset.pneProductInitialized === 'true') return;
    root.dataset.pneProductInitialized = 'true';

    const form=q('.pne-product-form',root), variantInput=q('[data-product-variant-id]',root), addBtn=q('[data-product-add]',root), price=q('[data-product-price]',root), code=q('[data-product-code]',root), stage=q('[data-product-stage]',root), gallery=q('[data-product-gallery]',root), quoteBtn=q('[data-product-quote]',root), filmstrip=q('[data-media-filmstrip]',root), counter=q('[data-media-counter]',root);
    const productJson=q('[data-product-json]',root);
    const variants=productJson ? JSON.parse(productJson.textContent) : [];

    const getMedia = () => qa('.pne-product-media',root).filter(m=>m.dataset.mediaId);
    const getThumbs = () => qa('[data-product-thumb]',root);

    const showMedia = (id, shouldScroll=true) => {
      const media=getMedia();
      const target=media.find(m=>String(m.dataset.mediaId)===String(id));
      if(!target) return;

      media.forEach(m=>{
        const active=m===target;
        m.classList.toggle('is-active',active);
        m.setAttribute('aria-hidden',active?'false':'true');
        if(!active) qa('video',m).forEach(v=>{ try{v.pause();}catch(e){} });
      });

      const thumbs=getThumbs();
      thumbs.forEach(b=>b.classList.toggle('is-active',String(b.dataset.mediaId)===String(id)));
      const index=media.indexOf(target);
      if(counter && index>=0) counter.textContent=`${String(index+1).padStart(2,'0')} / ${String(media.length).padStart(2,'0')}`;

      const activeThumb=thumbs.find(b=>String(b.dataset.mediaId)===String(id));
      if(activeThumb && filmstrip && shouldScroll){
        const left=activeThumb.offsetLeft-(filmstrip.clientWidth-activeThumb.offsetWidth)/2;
        filmstrip.scrollTo({left:Math.max(0,left),behavior:'smooth'});
      }
    };

    const initial=q('.pne-product-media.is-active',root) || getMedia()[0];
    if(initial) showMedia(initial.dataset.mediaId,false);

    getThumbs().forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.mediaId)));

    q('[data-product-prev]',root)?.addEventListener('click',()=>{
      const media=getMedia(); if(!media.length)return;
      const current=media.findIndex(m=>m.classList.contains('is-active'));
      const next=(current<=0?media.length:current)-1;
      showMedia(media[next].dataset.mediaId);
    });
    q('[data-product-next]',root)?.addEventListener('click',()=>{
      const media=getMedia(); if(!media.length)return;
      const current=media.findIndex(m=>m.classList.contains('is-active'));
      const next=(current+1)%media.length;
      showMedia(media[next].dataset.mediaId);
    });

    qa('[data-media-scroll]',root).forEach(btn=>btn.addEventListener('click',()=>{
      if(!filmstrip)return;
      const dir=Number(btn.dataset.mediaScroll)||1;
      filmstrip.scrollBy({left:dir*filmstrip.clientWidth*.78,behavior:'smooth'});
    }));

    // Linked editions are separate Shopify products. Keep the Museum Grade
    // configurator UI, but navigate to the real product page so media, price,
    // inventory, SEO and cart state always come from Shopify truth.
    qa('[data-edition-switch]',root).forEach(link=>{
      const prefetch=()=>{
        if(link.dataset.current==='true' || link.dataset.prefetched==='true') return;
        link.dataset.prefetched='true';
        const pf=document.createElement('link');
        pf.rel='prefetch'; pf.href=link.href; document.head.appendChild(pf);
      };
      link.addEventListener('mouseenter',prefetch,{once:true});
      link.addEventListener('focus',prefetch,{once:true});
      link.addEventListener('click',e=>{
        if(link.dataset.current==='true' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const target=link.href;
        qa('[data-edition-switch]',root).forEach(x=>x.classList.toggle('is-active',x===link));
        root.classList.toggle('pne-accent-blue',link.dataset.accent==='blue');
        root.classList.add('pne-edition-transition-out');
        const label=q('[data-product-status]',root);
        if(label) label.textContent='Switching edition…';
        window.setTimeout(()=>{ window.location.href=target; }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 390);
      });
    });

    qa('[data-option-position]',root).forEach(select=>select.addEventListener('change',()=>{
      const chosen=qa('[data-option-position]',root).map(s=>s.value);
      const variant=variants.find(v=>v.options.every((o,i)=>o===chosen[i]));
      if(!variant)return;
      if(variantInput) variantInput.value=variant.id;
      if(price) { price.innerHTML=formatShopMoney(variant.price); bucksReconvert(); }
      if(addBtn){addBtn.disabled=!variant.available;addBtn.textContent=variant.available?'Add to Collector Bag':'Sold Out';}
      if(code) code.textContent=variant.sku || root.dataset.productHandle.toUpperCase();
      if(variant.featured_media) showMedia(variant.featured_media.id);
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    }));

    qa('[data-product-region]',root).forEach(btn=>btn.addEventListener('click',()=>{
      qa('[data-product-region]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      const quote=btn.dataset.productRegion==='quote', route=q('[data-product-route]',root);
      if(route) route.textContent=quote?'Europe / Other · Quote required':`${btn.textContent.trim().startsWith('U.S.')?'U.S.':'Asia'} · Direct checkout`;
      if(form) form.hidden=quote;
      if(quoteBtn) quoteBtn.hidden=!quote;
    }));

    if(form && form.dataset.ajaxCart === 'true') form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(addBtn){addBtn.disabled=true;addBtn.dataset.oldText=addBtn.textContent;addBtn.textContent='Adding…';}
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!res.ok) throw new Error(await res.text());
        await refreshCart(true);
      }catch(err){console.warn(err); alert('Unable to add this item. Please review the selected configuration.');}
      finally{if(addBtn){addBtn.disabled=false;addBtn.textContent=addBtn.dataset.oldText||'Add to Collector Bag';}}
    });

    if(stage && gallery && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      stage.addEventListener('mousemove',e=>{const r=stage.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;gallery.style.transform=`rotateX(${(y-.5)*-1.25}deg) rotateY(${(x-.5)*1.8}deg) scale(1.0015)`;stage.style.setProperty('--mx',`${x*100}%`);stage.style.setProperty('--my',`${y*100}%`)});
      stage.addEventListener('mouseleave',()=>gallery.style.transform='');
    }
  };

  qa('[data-product-section]').forEach(initProductSection);
  document.addEventListener('shopify:section:load',e=>{
    const root=e.target.matches?.('[data-product-section]') ? e.target : q('[data-product-section]',e.target);
    if(root) initProductSection(root);
  });

  // Product recommendations lazy load
  qa('[data-product-recommendations]').forEach(section=>{
    if(section.innerHTML.trim()) return;
    fetch(section.dataset.url).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html'),fresh=doc.querySelector('[data-product-recommendations]');if(fresh){section.innerHTML=fresh.innerHTML;bucksReconvert();}});
  });

  // Announcement feed: editorial notices only
  qa('[data-pne-feed]').forEach(feed=>{
    const items=qa('[data-feed-item]',feed); if(!items.length)return;
    let i=0,timer; const interval=Math.max(5000,Number(feed.dataset.interval)||10000);
    const tick=()=>{items[i].classList.remove('is-active');i=(i+1)%items.length;items[i].classList.add('is-active');};
    if(items.length>1) timer=setInterval(tick,interval);
    q('[data-feed-close]',feed)?.addEventListener('click',()=>{clearInterval(timer);feed.remove();});
  });
})();
